export const statoryHolidayProvinceCardsData = [
	{
		header: "Alberta",
		shortCode: "AB",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployee: "(Formula for holiday worked)",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Average daily wage (4 weeks average or less)",
				id: "averagedailywage",
				value: "Average daily wage (4 weeks average or less)",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Average daily wage + Hours Worked * 1.5 * Rate",
				id: "averagedailywageemployee",
				value: "Average daily wage + Hours Worked * 1.5 * Rate",
			},
			{
				label: "Regular Rate * Hours Worked + Day off with pay",
				id: "regularRatEmployeeAlberta",
				value: "Regular Rate * Hours Worked + Day off with pay",
			},
		],
		continuousEmployeesOptions: [
			{
				label: "Average daily wage + Hours Worked * 1.5 * Rate",
				id: "averagedailywage",
				value: "Average daily wage + Hours Worked * 1.5 * Rate",
			},
			{
				label: "Regular Rate * Hours Worked + Day off with pay",
				id: "regularRateAlberta",
				value: "Regular Rate * Hours Worked + Day off with pay",
			},
		],

		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveAlberta",
		regularEmployeesOptionsName: "AlbertaRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"AlbertaRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName: "AlbertaContinuousEmployeesOptionName",
	},
	{
		header: "British Columbia",
		shortCode: "BC",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployee: "",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Average daily wage (Last 30 days)",
				id: "averageDailyWageLastBc",
				value: "Average daily wage (Last 30 days)",
			},
		],
		regularEmployeesOptions: [
			{
				label:
					"1.5 * Rate (first 12 hours) + 2.0 * Rate (after 12 hours) + Day Off with Holiday pay",
				id: "regularEmployeesBc",
				value:
					"1.5 * Rate (first 12 hours) + 2.0 * Rate (after 12 hours) + Day Off with Holiday pay",
			},
		],
		continuousEmployeesOptions: [""],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "BC day (Aug 04 2025)",
				value: "2025-08-04",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveBritishColumbia",
		regularEmployeesOptionsName: "BritishColumbiaregularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"BritishColumbiaRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName:
			"BritishColumbiaContinuousEmployeesOptionName",
	},
	{
		header: "Manitoba",
		shortCode: "MB",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployees: "(Formula for holiday worked)",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Regular Wage (Hourly Rate * 8 Hours)",
				id: "regularWageHourlyManitoba",
				value: "Regular Wage (Hourly Rate * 8 Hours)",
			},
			{
				label: "Average Daily Wage (4 weeks average or less)",
				id: "averageDailyWageWeekManitoba",
				value: "Average Daily Wage (4 weeks average or less)",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Regular Daily Wage (1.5 * Hourly Rate) * Hours Worked)",
				id: "regularWageHourlyManitoba",
				value: "Regular Daily Wage (1.5 * Hourly Rate) * Hours Worked)",
			},
		],
		continuousEmployeesOptions: [
			{
				label: "Regular Rate * Hours Worked + Day off with pay",
				id: "regularRateHourlyManitoba",
				value: "Regular Rate * Hours Worked + Day off with pay",
			},
		],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveManitoba",
		regularEmployeesOptionsName: "ManitobaRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"ManitobaRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName: "ManitobaContinuousEmployeesOptionName",
	},
	{
		header: "New Brunswick",
		shortCode: "NB",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployees: "(Formula for holiday worked)",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Regular Wage (Hourly Worked * 1.5 * Rate)",
				id: "holidayWageHourlyNB",
				value: "Regular Wage (Hourly Worked * 1.5 * Rate)",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Holiday Pay + Hours Worked * 1.5 * Rate",
				id: "holidayPay",
				value: "Holiday Pay + Hours Worked * 1.5 * Rate",
			},
		],
		continuousEmployeesOptions: [
			{
				label: "Holiday Pay + Hours Workd * 1.5 * Rate ",
				id: "holidayPayNB",
				value: "Holiday Pay + Hours Workd * 1.5 * Rate ",
			},
			{
				label: "Regular Wage (Hourly Rate x Hours Worked) + Day Off with pay",
				id: "regularRateNB",
				value: "Regular Wage (Hourly Rate x Hours Worked) + Day Off with pay",
			},
		],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveNewBrunswick",
		regularEmployeesOptionsName: "NewBrunswickRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"NewBrunswickRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName: "NewBrunswickContinuousEmployeesOptionName",
	},
	{
		header: "Newfoundland and Labrador",
		shortCode: "NL",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployees: "(Formula for holiday worked)",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Regular Wage (Hourly Rate * 8 Hours)",
				id: "regularWageHourlyNL",
				value: "Regular Wage (Hourly Rate * 8 Hours)",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Regular Wages + (Hourly Rate * Hours Worked)",
				id: "regularWagesHoursNL",
				value: "Regular Wages + (Hourly Rate * Hours Worked)",
			},
			{
				label: "(Hourly Rate * Hours Worked) + Day off with pay",
				id: "hourlyRateNL",
				value: "(Hourly Rate * Hours Worked) + Day off with pay",
			},
			{
				label:
					"(Hourly Rate * Hours Worked) + One additional day of vacation with pay",
				id: "hourlyRateVacationNL",
				value:
					"(Hourly Rate * Hours Worked) + One additional day of vacation with pay",
			},
		],
		continuousEmployeesOptions: [
			{
				label: "2 * Regular Rate * Hours Worked",
				id: "regularRateHoursNL",
				value: "2 * Regular Rate * Hours Worked",
			},
			{
				label: "Day off + Holiday pay (within 30 days)",
				id: "dayOffHolidayPayNL",
				value: "Day off + Holiday pay (within 30 days)",
			},
		],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveNewfoundlandAndLabrador",
		regularEmployeesOptionsName:
			"NewfoundlandandLabradorRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"NewfoundlandandLabradorRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName:
			"NewfoundlandandLabradorContinuousEmployeesOptionName",
	},
	{
		header: "Northwest Territories",
		shortCode: "NT",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployees: "",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Regular Wage (or average wages)",
				id: "regularWagesNT",
				value: "Regular Wage (or average wages)",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Holiday pay + (1.5 Hourly Rate) * Hours worked",
				id: "holidayPayHourlyNT",
				value: "Holiday pay + (1.5 Hourly Rate) * Hours worked",
			},
			{
				label: "Average daily wage + Another day off with Holiday Pay",
				id: "averageDailyWageNT",
				value: "Average daily wage + Another day off with Holiday Pay",
			},
		],
		continuousEmployeesOptions: [""],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveNorthwestTerritories",
		regularEmployeesOptionsName:
			"NorthwestTerritoriesRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"NorthwestTerritoriesRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName:
			"NorthwestTerritoriesContinuousEmployeesOptionName",
	},
	{
		header: "Nova Scotia",
		shortCode: "NS",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployee: "(Formula for holiday worked)",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Regular Wage (Hourly Rate * 8 Hours)",
				id: "regularWagesHourlyNS",
				value: "Regular Wage (Hourly Rate * 8 Hours)",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Regular pay + Hours Worked * 1.5 * Rate",
				id: "regularPayHoursNS",
				value: "Regular pay + Hours Worked * 1.5 * Rate",
			},
		],
		continuousEmployeesOptions: [
			{
				label: "Regular pay + Hours Worked * 1.5 * Rate",
				id: "regularPayHoursNS",
				value: "Regular pay + Hours Worked * 1.5 * Rate",
			},
		],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveNovaScotia",
		regularEmployeesOptionsName: "NovaScotiaRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"NovaScotiaRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName: "NovaScotiaContinuousEmployeesOptionName",
	},
	{
		header: "Nunavut",
		shortCode: "NU",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployee: "",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Regular Wages (or average wages)",
				id: "regularAverageWagesNU",
				value: "Regular Wages (or average wages)",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Holiday pay + (1.5 Hourly Rate) * Hours worked",
				id: "holidayPayHourlyNU",
				value: "Holiday pay + (1.5 Hourly Rate) * Hours worked",
			},
			{
				label: "Average daily wage + Another day off with Holiday Pay",
				id: "averageDailyWageNU",
				value: "Average daily wage + Another day off with Holiday Pay",
			},
		],
		continuousEmployeesOptions: [""],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveNunavut",
		regularEmployeesOptionsName: "NunavutRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"NunavutRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName: "NunavutContinuousEmployeesOptionName",
	},
	{
		header: "Ontario",
		shortCode: "ON",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployee: "(Formula for holiday worked)",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Average daily wage (4 weeks average or less)",
				id: "averagedailywageON",
				value: "Average daily wage (4 weeks average or less)",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Holiday pay + Hours worked * 1.5 * Rate",
				id: "holidayPayHourlyON",
				value: "Holiday pay + Hours worked * 1.5 * Rate",
			},
			{
				label: "Regular Wage + Day Off with Holiday Pay",
				id: "averageDailyWageON",
				value: "Regular Wage + Day Off with Holiday Pay",
			},
		],
		continuousEmployeesOptions: [
			{
				label: "Holiday pay + Hours worked * 1.5 * Rate",
				id: "holidayPayHourlyON",
				value: "Holiday pay + Hours worked * 1.5 * Rate",
			},
			{
				label: "Regular Wage + Day Off with Holiday Pay",
				id: "averageDailyWageON",
				value: "Regular Wage + Day Off with Holiday Pay",
			},
		],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveOntario",
		regularEmployeesOptionsName: "OntarioRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"OntarioRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName: "OntarioContinuousEmployeesOptionName",
	},
	{
		header: "Prince Edward Island",
		shortCode: "PE",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployee: "",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Regular wage (Hourly Rate * 8 Hours)",
				id: "regularWageRatePE",
				value: "Regular wage (Hourly Rate * 8 Hours)",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Regular daily wage + (1.5 * Hourly Rate) * Hours Worked",
				id: "regularDailyRateWagePE",
				value: "Regular daily wage + (1.5 * Hourly Rate) * Hours Worked",
			},
			{
				label: "Regular Rate * Hours Worked + Day off with pay",
				id: "regularRateHoursPE",
				value: "Regular Rate * Hours Worked + Day off with pay",
			},
		],
		continuousEmployeesOptions: [""],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectivePrinceEdwardIsland",
		regularEmployeesOptionsName: "PrinceEdwardIslandRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"PrinceEdwardIslandRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName:
			"PrinceEdwardIslandContinuousEmployeesOptionName",
	},
	{
		header: "Quebec",
		shortCode: "QC",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployees: "",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Average daily wage",
				id: "averagedailywageQC",
				value: "Average daily wage",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Holiday pay + Regular Rate * Hours Worked",
				id: "holidayPayRegularRateQC",
				value: "Holiday pay + Regular Rate * Hours Worked",
			},
			{
				label: "Regular Rate * Hours worked + day off without pay",
				id: "regularRateHoursWorkedQC",
				value: "Regular Rate * Hours worked + day off without pay",
			},
		],
		continuousEmployeesOptions: [""],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveQuebec",
		regularEmployeesOptionsName: "QuebecRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"QuebecRegularAndContinuousEmployees",
		ContinuousEmployeesOptionsName: "QuebecContinuousEmployeesOptionName",
	},
	{
		header: "Saskatchewan",
		shortCode: "SK",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployees: "",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Period Regular Wage / No. of Days in period",
				id: "periodRegularWage",
				value: "Period Regular Wage / No. of Days in period",
			},
			{
				label:
					"Total wages earned in four weeks immediately preceding the holiday (excluding overtime but including vacation pay) / 20",
				id: "totalPeriodRegularWage",
				value:
					"Total wages earned in four weeks immediately preceding the holiday (excluding overtime but including vacation pay) / 20",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Holiday pay + 1.5 * Hourly Rate * hours worked",
				id: "holidayPayHourlysaskatchewan",
				value: "Holiday pay + 1.5 * Hourly Rate * hours worked",
			},
		],
		continuousEmployeesOptions: [
			{
				label: "Regular wages + (1.5 * Hourly Rate) * hours worked",
				id: "regularWagesSaskatchewan",
				value: "Regular wages + (1.5 * Hourly Rate) * hours worked",
			},

			{
				label: "1.5 * Hourly Rate * Hours worked + day off with pay",
				id: "1.5HourlyRateSaskatchewan",
				value: "1.5 * Hourly Rate * Hours worked + day off with pay",
			},
		],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveSaskatchewan",
		regularEmployeesOptionsName: "SaskatchewanRegularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"SaskatchewanRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName: "SaskatchewanContinuousEmployeesOptionName",
	},
	{
		header: "Yukon",
		shortCode: "YT",
		regularEmployees: "(Formula for holiday worked)",
		continuousEmployees: "",
		regularAndContinuousEmployees: "(Formula for holiday not worked)",
		regularAndContinuousEmployeesOptions: [
			{
				label: "Regular wage (Hourly Rate * 8 Hours)",
				id: "regularWageHourlyYT",
				value: "Regular wage (Hourly Rate * 8 Hours)",
			},
		],
		regularEmployeesOptions: [
			{
				label: "Holiday pay + Hours Worked * 1.5 * Rate",
				id: "holidayPayHourlyYT",
				value: "Holiday pay + Hours Worked * 1.5 * Rate",
			},
			{
				label: "Regular Rate * Hours worked + day off with pay",
				id: "regularRateHoursWorkedYT",
				value: "Regular Rate * Hours worked + day off with pay",
			},
		],
		continuousEmployeesOptions: [""],
		dateEffectiveItems: [
			{
				label: "Christmas Day (Dec 25 2024)",
				value: "2024-12-25",
			},
			{
				label: "Labour day (Sep 01 2025)",
				value: "2025-09-01",
			},
		],
		dateEffectiveId: "dateEffectiveYukon",
		regularEmployeesOptionsName: "YukonregularEmployeesOptionName",
		regularAndContinousEmployeesOptionsName:
			"YukonRegularAndContinuousEmployeesOptionName",
		ContinuousEmployeesOptionsName: "YukoncontinuousEmployeesOptionName",
	},
];

export const provinceCardsData: any = {
	AB: {
		dateField: "dateEffectiveAlberta",
		rules: [
			{
				ruleType: 200,
				value: "Average daily wage (4 weeks average or less)",
			},
			{ ruleType: 300, valueField: "AlbertaRegularEmployeesOptionName" },
			{
				ruleType: 100,
				valueField: "AlbertaContinuousEmployeesOptionName",
			},
		],
	},
	BC: {
		dateField: "dateEffectiveBritishColumbia",
		rules: [
			{ ruleType: 200, value: "Average daily wage (Last 30 days)" },
			{
				ruleType: 300,
				value:
					"1.5 * Rate (first 12 hours) + 2.0 * Rate (after 12 hours) + Day Off with Holiday pay",
			},
		],
	},
	MB: {
		dateField: "dateEffectiveManitoba",
		rules: [
			{
				ruleType: 200,
				valueField: "ManitobaRegularAndContinuousEmployeesOptionName",
			},
			{
				ruleType: 300,
				value: "Regular Daily Wage (1.5 * Hourly Rate) * Hours Worked)",
			},
			{
				ruleType: 100,
				value: "Regular Rate * Hours Worked + Day off with pay",
			},
		],
	},
	NB: {
		dateField: "dateEffectiveNewBrunswick",
		rules: [
			{
				ruleType: 200,
				value: "Regular Wage (Hourly Worked * 1.5 * Rate)",
			},
			{ ruleType: 300, value: "Holiday Pay + Hours Worked * 1.5 * Rate" },
			{
				ruleType: 100,
				valueField: "NewBrunswickContinuousEmployeesOptionName",
			},
		],
	},
	NL: {
		dateField: "dateEffectiveNewfoundlandAndLabrador",
		rules: [
			{ ruleType: 200, value: "Regular Wage (Hourly Rate * 8 Hours)" },
			{
				ruleType: 300,
				valueField: "NewfoundlandandLabradorRegularEmployeesOptionName",
			},
			{
				ruleType: 100,
				valueField: "NewfoundlandandLabradorContinuousEmployeesOptionName",
			},
		],
	},
	NT: {
		dateField: "dateEffectiveNorthwestTerritories",
		rules: [
			{ ruleType: 200, value: "Regular Wage (or average wages)" },
			{
				ruleType: 300,
				valueField: "NorthwestTerritoriesRegularEmployeesOptionName",
			},
		],
	},
	NS: {
		dateField: "dateEffectiveNovaScotia",
		rules: [
			{ ruleType: 200, value: "Regular Wage (Hourly Rate * 8 Hours)" },
			{ ruleType: 300, value: "Regular pay + Hours Worked * 1.5 * Rate" },
			{ ruleType: 100, value: "Regular pay + Hours Worked * 1.5 * Rate" },
		],
	},
	NU: {
		dateField: "dateEffectiveNunavut",
		rules: [
			{ ruleType: 200, value: "Regular Wages (or average wages)" },
			{ ruleType: 300, valueField: "NunavutRegularEmployeesOptionName" },
		],
	},
	ON: {
		dateField: "dateEffectiveOntario",
		rules: [
			{
				ruleType: 200,
				value: "Average daily wage (4 weeks average or less)",
			},
			{ ruleType: 300, valueField: "OntarioRegularEmployeesOptionName" },
			{
				ruleType: 100,
				valueField: "OntarioContinuousEmployeesOptionName",
			},
		],
	},
	PE: {
		dateField: "dateEffectivePrinceEdwardIsland",
		rules: [
			{ ruleType: 200, value: "Regular wage (Hourly Rate * 8 Hours)" },
			{
				ruleType: 300,
				valueField: "PrinceEdwardIslandRegularEmployeesOptionName",
			},
		],
	},
	QC: {
		dateField: "dateEffectiveQuebec",
		rules: [
			{ ruleType: 200, value: "Average daily wage" },
			{ ruleType: 300, valueField: "QuebecRegularEmployeesOptionName" },
		],
	},
	SK: {
		dateField: "dateEffectiveSaskatchewan",
		rules: [
			{
				ruleType: 200,
				valueField: "SaskatchewanRegularAndContinuousEmployeesOptionName",
			},
			{
				ruleType: 300,
				value: "Holiday pay + 1.5 * Hourly Rate * hours worked",
			},
			{
				ruleType: 100,
				valueField: "SaskatchewanContinuousEmployeesOptionName",
			},
		],
	},
	YT: {
		dateField: "dateEffectiveYukon",
		rules: [
			{ ruleType: 200, value: "Regular wage (Hourly Rate * 8 Hours)" },
			{ ruleType: 300, valueField: "YukonregularEmployeesOptionName" },
		],
	},
};

export const provinceMap = {
	AB: {
		label: "Alberta",
		dateField: "dateEffectiveAlberta",
		fields: [
			"AlbertaRegularAndContinuousEmployeesOptionName",
			"AlbertaContinuousEmployeesOptionName",
			"AlbertaRegularEmployeesOptionName",
		],
	},
	BC: {
		label: "British Columbia",
		dateField: "dateEffectiveBritishColumbia",
		fields: [
			"BritishColumbiaRegularAndContinuousEmployeesOptionName",
			"BritishColumbiaContinuousEmployeesOptionName",
			"BritishColumbiaregularEmployeesOptionName",
		],
	},
	MB: {
		label: "Manitoba",
		dateField: "dateEffectiveManitoba",
		fields: [
			"ManitobaRegularAndContinuousEmployeesOptionName",
			"ManitobaContinuousEmployeesOptionName",
			"ManitobaRegularEmployeesOptionName",
		],
	},
	NB: {
		label: "New Brunswick",
		dateField: "dateEffectiveNewBrunswick",
		fields: [
			"NewBrunswickRegularAndContinuousEmployeesOptionName",
			"NewBrunswickContinuousEmployeesOptionName",
			"NewBrunswickRegularEmployeesOptionName",
		],
	},
	NL: {
		label: "Newfoundland and Labrador",
		dateField: "dateEffectiveNewfoundlandAndLabrador",
		fields: [
			"NewfoundlandandLabradorRegularAndContinuousEmployeesOptionName",
			"NewfoundlandandLabradorContinuousEmployeesOptionName",
			"NewfoundlandandLabradorRegularEmployeesOptionName",
		],
	},
	NT: {
		label: "Northwest Territories",
		dateField: "dateEffectiveNorthwestTerritories",
		fields: [
			"NorthwestTerritoriesRegularAndContinuousEmployeesOptionName",
			"NorthwestTerritoriesContinuousEmployeesOptionName",
			"NorthwestTerritoriesRegularEmployeesOptionName",
		],
	},
	NS: {
		label: "Nova Scotia",
		dateField: "dateEffectiveNovaScotia",
		fields: [
			"NovaScotiaRegularAndContinuousEmployeesOptionName",
			"NovaScotiaContinuousEmployeesOptionName",
			"NovaScotiaRegularEmployeesOptionName",
		],
	},
	NU: {
		label: "Nunavut",
		dateField: "dateEffectiveNunavut",
		fields: [
			"NunavutRegularAndContinuousEmployeesOptionName",
			"NunavutContinuousEmployeesOptionName",
			"NunavutRegularEmployeesOptionName",
		],
	},
	ON: {
		label: "Ontario",
		dateField: "dateEffectiveOntario",
		fields: [
			"OntarioRegularAndContinuousEmployeesOptionName",
			"OntarioContinuousEmployeesOptionName",
			"OntarioRegularEmployeesOptionName",
		],
	},
	PE: {
		label: "Prince Edward Island",
		dateField: "dateEffectivePrinceEdwardIsland",
		fields: [
			"PrinceEdwardIslandRegularAndContinuousEmployeesOptionName",
			"PrinceEdwardIslandContinuousEmployeesOptionName",
			"PrinceEdwardIslandRegularEmployeesOptionName",
		],
	},
	QC: {
		label: "Quebec",
		dateField: "dateEffectiveQuebec",
		fields: [
			"QuebecRegularAndContinuousEmployees",
			"QuebecContinuousEmployeesOptionName",
			"QuebecRegularEmployeesOptionName",
		],
	},
	SK: {
		label: "Saskatchewan",
		dateField: "dateEffectiveSaskatchewan",
		fields: [
			"SaskatchewanRegularAndContinuousEmployeesOptionName",
			"SaskatchewanContinuousEmployeesOptionName",
			"SaskatchewanRegularEmployeesOptionName",
		],
	},
	YT: {
		label: "Yukon",
		dateField: "dateEffectiveYukon",
		fields: [
			"YukonRegularAndContinuousEmployeesOptionName",
			"YukoncontinuousEmployeesOptionName",
			"YukonregularEmployeesOptionName",
		],
	},
};
